module.exports = __webpack_public_path__ + "account/img/41.2d8b3f62.png";